import React, { ChangeEvent } from 'react';
import { Direction } from '../../graphql/schema/p4types';

type IReactDataGridContext = {
  handleRowSelect: (rowIdx: number, columnKey: string, rowData: any, e: ChangeEvent) => void;
  handleSort: (sortColumn: string, sortDirection: Direction) => void;
};

const ReactDataGridContext = React.createContext({} as IReactDataGridContext);
export default ReactDataGridContext;
